<template>
	<div class="trim form">
		<ValidationObserver v-slot="{ errors, handleSubmit }" @submit.prevent>
			<h4 class="step-title">
				<label for="VehicleTrim"
					>{{ vehicle.make }} {{ vehicle.model }} Vehicle Trim</label
				>
			</h4>
			<div
				class="step-content d-flex flex-column align-items-center step-button-list wider"
			>
				<scrollable-button-list
					v-bind:items="trims"
					v-bind:onclick="trimComplete"
					v-if="trims.length > 0"
					v-bind:value="vehicle.trim"
				/>
				<div
					class="step-item"
					v-if="trimRequired && vehicle.trim === null"
				>
					<div class="alert alert-danger">Trim required</div>
				</div>
				<div class="step-item" v-if="trims.length == 0">
					<ValidationProvider
						mode="eager"
						vid="vehicleTrim"
						name="Vehicle trim"
						rules="required"
					>
						<input
							id="vehicleTrimText"
							class="form-control"
							type="text"
							v-on:keyup.enter="enterKeyup"
							v-model="vehicle.trim"
						/>
					</ValidationProvider>
					<div
						class="step-item"
						v-if="
							errors['vehicleTrim'] &&
							errors['vehicleTrim'].length > 0
						"
					>
						<div class="alert alert-danger">
							{{ errors["vehicleTrim"][0] }}
						</div>
					</div>
				</div>
			</div>
			<h4 class="step-title">Is the vehicle leased or owned?</h4>
			<div
				class="step-content d-flex flex-column align-items-center step-button-list wider"
			>
				<button-list
					v-bind:items="ownershipTypes"
					v-bind:onclick="
						(value) => {
							handleSubmit(() => vehicleOwnershipComplete(value));
						}
					"
					v-bind:value="vehicle.ownershipType"
				/>
				<div
					class="step-item"
					v-if="
						(trimRequired && vehicle.trim === null) ||
						(errors['vehicleTrim'] &&
							errors['vehicleTrim'].length > 0)
					"
				>
					<div class="alert alert-danger">
						Required question(s) not answered
					</div>
				</div>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
import ScrollableButtonList from "../shared/ScrollableButtonList.vue";
import ButtonList from "../shared/ButtonList.vue";

import { extend } from "vee-validate";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
	...required,
	message: "{_field_} is required.",
});

export default {
	name: "VehicleTrimAndVehicleOwnershipType",
	components: {
		ScrollableButtonList,
		ButtonList,
		ValidationProvider,
		ValidationObserver,
	},
	props: {
		appState: Object,
		lead: Object
	},
	data: function () {
		return {
			trims: [],
			trimRequired: false,
			ownershipTypes: [
				{ text: "Leased", value: "Lease" },
				{ text: "Owned", value: "Own" },
			],
		};
	},
	created: function () {
		this.loadTrims();
	},
	computed: {
		vehicle: function () {
			return this.lead.autoInsurance.vehicles[
				this.lead.autoInsurance.vehicles.length - 1
			];
		},
	},
	methods: {
		loadTrims: function() {
            var makeModelTrims = this.appState.makeModelTrimsByYear[this.vehicle.year];
            if (makeModelTrims) {

                var modelTrims = makeModelTrims[this.vehicle.make];

                if (modelTrims) {

                    var trims = this.trims;

                    modelTrims[this.vehicle.model].forEach(trimToAdd => {
                        trims.push({ text: trimToAdd, value: trimToAdd });
                    });
                }
            }
        },
		enterKeyup: function () {
			this.$refs.complete.click();
		},
		trimComplete: function (value) {
			if (value) {
				this.vehicle.trim = value;
			}

			if (this.trimRequired && this.vehicle.ownershipType !== null) {
				this.complete(this.vehicle.ownershipType);
			}
		},
		vehicleOwnershipComplete: function (value) {
			if (this.vehicle.trim === null) {
				this.trimRequired = true;
			}

			this.vehicle.ownershipType = value;

			if (this.vehicle.trim !== null) {
				this.complete(value);
			}
		},
		complete: function (vehicleOwnershipTypeValue) {
			this.$emit(
				"complete",
				this.$options.name,
				vehicleOwnershipTypeValue
			);
		},
	},
};
</script>

<style scoped>
#VehicleTrim {
	max-width: 175px;
}
</style>
